import React, { Component, Fragment } from 'react';
import './Selectables.module.scss';
import chroma from 'chroma-js';

/**
 * Import components
 */

import { Creatable } from 'react-select';
import Select from 'react-select';
/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const customStyles = {
    control: styles => ({ 
        ...styles, 
        fontSize: '12px',
    }),
    option: styles => ({
        ...styles,
        fontSize: '12px',
    })
};

export class Creator extends Component {

    constructor() {
        super();
    }
    render() {

        return (

            <Creatable
                styles={customStyles}
                onCreateOption={this.props.handleCreate} 
                onChange={this.props.handleChange} 
                value={this.props.value} 
                options={this.props.options}
                placeholder={this.props.placeholder}
                formatCreateLabel={userInput => `Voeg '${userInput}' toe`}/>
            
        );
    }
}

export class Selector extends Component {
    constructor() {
        super();
    }
    render() {

        return (
            <Select 
                id='select-color' 
                //onChange={(value)=>this.handleColorChange(value)} 
                // value={valueFromId(colorsFormatted, new_usersubject.color)}
                label="Kleur" 
                styles={customStyles} 
                components={{
                    IndicatorSeparator: () => null
                }}
                placeholder='Selecteer kleur'
                //options={colorsFormatted}
            />
            
        );
    }
}
